if (!customElements.get("td-tab-select")) {
  class TdTabSelect extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('[data-button-index]'));
      this.contents = Array.from(this.querySelectorAll('[data-content-index]'));
      this.images = Array.from(this.querySelectorAll('[data-image-index]'));
      
      this.activeIndex = 0;
    }

    connectedCallback() {
      this.setupTabs(this.tabs);
      this.updateActiveTab(this.activeIndex);
    }

    setupTabs(tabs) {
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = parseInt(tab.dataset.buttonIndex, 10);
          this.updateActiveTab(index);
        });
      });
    }

    updateActiveTab(index) {
      if (index < 0 || index >= this.tabs.length) {
        console.error('Invalid tab index:', index);
        return;
      }

      this.activeIndex = index;

      this.tabs.forEach((tab) => {
        tab.classList.toggle('tab-button--active', parseInt(tab.dataset.buttonIndex, 10) === index);
        tab.classList.toggle('tab-button-inactive', parseInt(tab.dataset.buttonIndex, 10) !== index);
      });

      this.contents.forEach((content) => {
        const isActive = parseInt(content.dataset.contentIndex, 10) === index;
        content.classList.toggle('td-ts__content-active', isActive);
        content.classList.toggle('td-ts__content-inactive', !isActive);
      });


      this.images.forEach((image) => {
        const isActive = parseInt(image.dataset.imageIndex, 10) === index;
        image.classList.toggle('td-ts__image-active', isActive);
        image.classList.toggle('td-ts__image-inactive', !isActive);
      });
    }
  }

  customElements.define("td-tab-select", TdTabSelect);
}
